var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},_vm._l((_vm.imgdata),function(item,i){return _c('div',{key:i,staticClass:"menu-item",on:{"click":function($event){return _vm.check(i)}}},[_c('img',{attrs:{"src":item.src}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }